<template>
  <v-container fluid class="tax-feedback-settings-page">
    <v-toolbar color="primary" class="header-title text-white mb-4" rounded="lg">
      <v-toolbar-title class="title">{{ $t('taxFeedbackSettingsPageTitle') }}</v-toolbar-title>
    </v-toolbar>
    <TaxFeedbackReasonSettings />
  </v-container>
</template>

<script setup>
import TaxFeedbackReasonSettings from '../components/TaxFeedback/TaxFeedbackReasonSettings.vue';
</script>
